@layer ch-tabular-grid {
  ch-tabular-grid-column-display {
    position: fixed !important;
    width: 0 !important;
    height: 0 !important;
    padding: 0 !important;
    border: none !important;
    margin: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    pointer-events: none !important;
  }
}
